var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bot-container"},[_c('ChatBox'),_c('v-btn',{attrs:{"elevation":"2","fab":"","color":"#DD4F40"},on:{"click":function($event){return _vm.$store.commit('chatbot/setShowChatBox', !_vm.$store.state.chatbot.showChatBox)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-chat")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }